module.exports = __webpack_public_path__ + "img/contact.59e97333.jpg";